import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import ListLinkBox from '../../../components/UI/ListLinkBox';
import { translate } from '../../../utils/util';
import BackButton from '../../../components/UI/BackButton';
import ContainerService from '../../../services/ContainerService';
import { checkPermission } from '../../../services/auth';
import { PERMISSIONS } from '../../../utils/constants';

const Config = (props) => {

    useEffect(() => {
        props.getPlantConfig();
        props.getContainerTypes();
        props.getContainerSizes();
        props.getBusinessHoursConfig();
    }, []);

    const menu = () => {
        let menuItems = [];

        if (checkPermission(PERMISSIONS.Warehouse_Container.Config.Patio) || checkPermission(PERMISSIONS.Warehouse_Container.Config.PatioSearch)) {  
            menuItems = [...menuItems, { route: 'config/patio', icon: 'mdi mdi-location-enter', text: translate('container:config:menu.patio') }];
        }

        if (checkPermission(PERMISSIONS.Warehouse_Container.Config.UnloadLocation) || checkPermission(PERMISSIONS.Warehouse_Container.Config.UnloadLocationSearch)) {
            menuItems = [...menuItems, { route: 'config/unloadlocation', icon: 'mdi mdi-location-enter', text: translate('container:menu.unload-location') }];
        }

        //menuItems = [...menuItems, { route: 'config/containertype', icon: 'mdi mdi-location-enter', text: translate('container:config:menu.container-types') }];
        if (checkPermission(PERMISSIONS.Warehouse_Container.Config.ContainerSize) || checkPermission(PERMISSIONS.Warehouse_Container.Config.ContainerSizeSearch)) {  
            menuItems = [...menuItems, { route: 'config/containersize', icon: 'mdi mdi-location-enter', text: translate('container:config:menu.container-sizes') }];
        }

        if (checkPermission(PERMISSIONS.Warehouse_Container.Config.ExecutionCalculation) || checkPermission(PERMISSIONS.Warehouse_Container.Config.ExecutionCalculationSearch)) {  
            menuItems = [...menuItems, { route: 'config/executioncalculation', icon: 'mdi mdi-location-enter', text: translate('container:config:menu.execution-calculation') }];
        }

        if (checkPermission(PERMISSIONS.Warehouse_Container.Config.IssuerRegistration) || checkPermission(PERMISSIONS.Warehouse_Container.Config.IssuerRegistrationSearch)) {  
            menuItems = [...menuItems, { route: 'config/issuercoderegistration', icon: 'mdi mdi-location-enter', text: translate('container:config:menu.issuer-code-registration') }];
        }

        if (checkPermission(PERMISSIONS.Warehouse_Container.Config.PlantConfig) || checkPermission(PERMISSIONS.Warehouse_Container.Config.PlantConfigSearch)) {  
            menuItems = [...menuItems, { route: 'config/plantconfig', icon: 'mdi mdi-location-enter', text: translate('container:config:menu.plant-config') }];
        }

        if (checkPermission(PERMISSIONS.Warehouse_Container.Config.BussinesHourConfig) || checkPermission(PERMISSIONS.Warehouse_Container.Config.BussinesHourConfigSearch)) {  
            menuItems = [...menuItems, { route: 'config/businesshoursconfig', icon: 'mdi mdi-location-enter', text: translate('container:config:menu.business-hours-config') }];
        }

        if (checkPermission(PERMISSIONS.Warehouse_Container.Config.MaritimeCompany) || checkPermission(PERMISSIONS.Warehouse_Container.Config.MaritimeCompanySearch)) {  
            menuItems = [...menuItems, { route: 'config/maritimeCompany', icon: 'mdi mdi-location-enter', text: "Companhias Marítimas" }];
        }

        if (checkPermission(PERMISSIONS.Warehouse_Container.Config.Harbor) || checkPermission(PERMISSIONS.Warehouse_Container.Config.HarborSearch)) {  
            menuItems = [...menuItems, { route: 'config/harbor', icon: 'mdi mdi-location-enter', text: "Portos" }];
        }

        if (checkPermission(PERMISSIONS.Warehouse_Container.Config.Freetime) || checkPermission(PERMISSIONS.Warehouse_Container.Config.FreetimeSearch)) {  
            menuItems = [...menuItems, { route: 'config/freetime', icon: 'mdi mdi-location-enter', text: "FreeTime" }];
        }

        if (checkPermission(PERMISSIONS.Warehouse_Container.Config.MDR) || checkPermission(PERMISSIONS.Warehouse_Container.Config.MDRSearch)) {  
            menuItems = [...menuItems, { route: 'config/mdr', icon: 'mdi mdi-location-enter', text: "Embalagem" }];
        }

        return menuItems;
    };

    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65">
                <div className="row">
                    <div className="title">
                        <i className="mdi mdi-clipboard-check-outline" />
                        {translate('container:menu.config')}
                    </div>
                </div>
            </div>
            <div className="container" style={{ marginLeft: '5px', marginTop: '40px', }}>
                <ListLinkBox
                    options={menu()}
                />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getPlantConfig: (callback) => {
            dispatch(ContainerService.getPlantConfig(callback));
        },
        getContainerTypes: () => {
            dispatch(ContainerService.getContainerTypes());
        },
        getContainerSizes: () => {
            dispatch(ContainerService.getContainerSizes());
        },
        getBusinessHoursConfig: (callback) => {
            dispatch(ContainerService.getBusinessHoursConfig(callback));
        }
    };
};


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withRouter(withTranslation()(Config))));

